import photo01 from "../../assets/images/photo-01.jpeg";
import photo02 from "../../assets/images/photo-02.jpeg";
import photo03 from "../../assets/images/photo-03.jpeg";
import photo04 from "../../assets/images/photo-04.jpeg";
import photo05 from "../../assets/images/photo-05.jpeg";
import photo06 from "../../assets/images/photo-06.jpeg";
import photo07 from "../../assets/images/photo-07.jpeg";
import photo08 from "../../assets/images/photo-08.jpeg";
import photo09 from "../../assets/images/photo-09.jpeg";
import photo10 from "../../assets/images/photo-10.jpeg";
import photo11 from "../../assets/images/photo-11.jpeg";
import photo12 from "../../assets/images/photo-12.jpeg";
import photo13 from "../../assets/images/photo-13.jpeg";
import photo14 from "../../assets/images/photo-14.jpeg";
import photo15 from "../../assets/images/photo-15.jpeg";
import photo16 from "../../assets/images/photo-16.jpeg";

import article01 from "../md/article01.md";
import article02 from "../md/article02.md";
import article03 from "../md/article03.md";
import article04 from "../md/article04.md";
import article05 from "../md/article05.md";
import article06 from "../md/article06.md";
import article07 from "../md/article07.md";
import article08 from "../md/article08.md";
import article09 from "../md/article09.md";
import article10 from "../md/learnGatsby.md";
import article11 from "../md/learnReact.md";
import article12 from "../md/surveyJS.md";
import article13 from "../md/whatIsJS.md";
import article14 from "../md/www.md";
import article15 from "../md/article15.md";
import article16 from "../md/article16.md";

export const photos = {
  photo01,
  photo02,
  photo03,
  photo04,
  photo05,
  photo06,
  photo07,
  photo08,
  photo09,
  photo10,
  photo11,
  photo12,
  photo13,
  photo14,
  photo15,
  photo16,
};

export const articles = {
  article01,
  article02,
  article03,
  article04,
  article05,
  article06,
  article07,
  article08,
  article09,
  article10,
  article11,
  article12,
  article13,
  article14,
  article15,
  article16,
};
